import _danhmuc from "./menus/danhmuc";
import _system from "./menus/system";
import _chucnang from "./menus/chucnang";

const routes = [
  //************ CHỨC NĂNG ****************
  ..._chucnang,

  //************ SYSTEM ****************
  ..._system,

  //************ DANH MỤC - Mục đích để mở popup danh mục nhanh ****************
  ..._danhmuc,
];

export default routes;
